<template>
  <a-drawer width="420px" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item label="上级类型" prop="parentId">
        <a-tree-select
          v-model="form.parentId"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '360px', overflow: 'auto' }"
          :tree-data="parentOptions"
          placeholder="顶级目录"
          allow-clear
          tree-default-expand-all
          :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
        />
      </a-form-model-item>
      <a-form-model-item label="类型编码" prop="categoryCode">
        <a-input v-model="form.categoryCode" placeholder="请输入编码" :disabled="!!form.id" />
      </a-form-model-item>
      <a-form-model-item label="类型名称" prop="categoryName">
        <a-input v-model="form.categoryName" placeholder="请输入名称" />
      </a-form-model-item>
      <a-form-model-item label="排序号" prop="sortNo">
        <a-input-number v-model="form.sortNo" :min="0" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="匹配客商类型" prop="matchCustomerType">
        <a-input v-model="form.matchCustomerType" placeholder="可选，对应 Demo 标签" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" type="textarea" :rows="2" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addCustomerCategory, editCustomerCategory } from '@/api/erp/customerCategory'

export default {
  name: 'CustomerCategoryForm',
  props: {
    parentOptions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      open: false,
      submitLoading: false,
      formTitle: '',
      form: {
        id: undefined,
        parentId: 0,
        categoryCode: undefined,
        categoryName: undefined,
        sortNo: 0,
        matchCustomerType: undefined,
        remark: undefined
      },
      rules: {
        categoryCode: [{ required: true, message: '类型编码不能为空', trigger: 'blur' }],
        categoryName: [{ required: true, message: '类型名称不能为空', trigger: 'blur' }],
        sortNo: [{ required: true, message: '排序号不能为空', trigger: 'change' }]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        id: undefined,
        parentId: 0,
        categoryCode: undefined,
        categoryName: undefined,
        sortNo: 0,
        matchCustomerType: undefined,
        remark: undefined
      }
    },
    handleAdd (parent) {
      this.reset()
      if (parent && parent.id) {
        this.form.parentId = parent.id
      } else {
        this.form.parentId = 0
      }
      this.formTitle = '新建客户类型'
      this.open = true
    },
    handleUpdate (record) {
      this.reset()
      this.form = {
        id: record.id,
        parentId: record.parentId == null ? 0 : record.parentId,
        categoryCode: record.categoryCode,
        categoryName: record.categoryName,
        sortNo: record.sortNo == null ? 0 : record.sortNo,
        matchCustomerType: record.matchCustomerType,
        remark: record.remark
      }
      this.formTitle = '编辑客户类型'
      this.open = true
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = {
          ...this.form,
          parentId: this.form.parentId == null ? 0 : this.form.parentId
        }
        const req = payload.id ? editCustomerCategory(payload) : addCustomerCategory(payload)
        req.then(res => {
          if (res.success || res.code === 20001 || res.code === 200 || res.code === '20001') {
            this.$message.success('保存成功')
            this.open = false
            this.$emit('ok')
          } else {
            this.$message.error(res.message || res.msg || '保存失败')
          }
        }).catch(() => {
          this.$message.error('保存失败')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
